import { NgClass, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostListener, Inject, Input } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { ViewportImagePosition } from '@ng-cloud/badger-core';
import { StartCasePipe } from '@ng-cloud/badger-core/common/pipes/start-case.pipe';

import { InsightImage } from '@ng-cloud/badger-core/models/interfaces/insight-image';
import { ClassDirective, StyleDirective } from '@ngbracket/ngx-layout/extended';
import { FlexFillDirective } from '@ngbracket/ngx-layout/flex';
import { InsightImageComponent } from '../insight-image.component';

@Component({
  selector: 'bt-insight-image-dialog',
  templateUrl: './insight-image-dialog.component.html',
  styleUrls: ['./insight-image-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ClassDirective,
    FlexFillDirective,
    InsightImageComponent,
    MatDialogClose,
    MatDialogContent,
    MatIcon,
    MatIconButton,
    NgClass,
    NgStyle,
    StartCasePipe,
    StyleDirective
  ]
})
export class InsightImageDialogComponent {
  protected selectedIndex = -1;
  protected infoText: string;
  protected selectedImage: InsightImage;
  private _insightImages: InsightImage[];

  @HostListener('window:keydown.arrowRight')
  @HostListener('window:keydown.arrowDown')
  protected selectNext() {
    this.selectNextImage(true);
  }

  @HostListener('window:keydown.arrowLeft')
  @HostListener('window:keydown.arrowUp')
  protected selectPrevious() {
    this.selectNextImage(false);
  }

  constructor(
    public dialogRef: MatDialogRef<InsightImageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.selectedIndex = data.selectedIndex;
    this.infoText = data.infoText;
    this.insightImages = data['images'];
  }

  @Input() set insightImages(insightImages: InsightImage[]) {
    this._insightImages = insightImages;

    if (this._insightImages) {
      if (this.insightImages.length > 0) {
        this.setSelectedImage();
      }
    }
  }

  get insightImages(): InsightImage[] {
    return this._insightImages;
  }

  selectNextImage(forward = true) {
    forward ? this.selectedIndex++ : this.selectedIndex--;

    if (this.selectedIndex > this.insightImages.length - 1) {
      this.selectedIndex = 0;
    }
    else if (this.selectedIndex < 0) {
      this.selectedIndex = this.insightImages.length - 1;
    }

    this.setSelectedImage();
  }

  protected selectImage(i: number) {
    this.selectedIndex = i;

    this.setSelectedImage();
  }

  private setSelectedImage() {
    this.selectedImage = this.insightImages[this.selectedIndex];
  }

  protected readonly ViewportImagePosition = ViewportImagePosition;
}
